<div class="flex justify-between header">
  <h2 color="primary">Recap bonifici</h2>
  <button mat-icon-button mat-dialog-close aria-label="Chiudi" matTooltip="Chiudi">
    <mat-icon>clear</mat-icon>
  </button>
</div>
<app-dialog-header [praticaCode]="data.pratica?.praticaCode || ''" [denominazione]="data.pratica?.denomination || ''">
</app-dialog-header>

<mat-dialog-content class="double-header-dialog-content">
  <div class="scrollable-table-container">
    <table mat-table [dataSource]="recapDataSource" class="table table-primary-color">
      <ng-container matColumnDef="property">
        <td mat-cell *matCellDef="let element" class="bold">{{element.property}}</td>
      </ng-container>

      <ng-container matColumnDef="value">
        <td mat-cell *matCellDef="let element">{{element.value}}</td>
      </ng-container>
      <tr mat-row *matRowDef="let row; columns: recapColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" style="text-align: center; padding: 20px 0;" colspan="4">Nessuna informazione presente al
          momento.
        </td>
      </tr>
    </table>
  </div>

  <div class="scrollable-table-container">
    <table mat-table [dataSource]="dataSource" class="table table-primary-color">



      <ng-container matColumnDef="voce">
        <th mat-header-cell *matHeaderCellDef> Voce </th>
        <td mat-cell *matCellDef="let element">{{element.voce}}</td>
      </ng-container>

      <ng-container matColumnDef="iban">
        <th mat-header-cell *matHeaderCellDef> IBAN </th>
        <td mat-cell *matCellDef="let element">{{element.iban}}</td>
      </ng-container>

      <ng-container matColumnDef="causale">
        <th mat-header-cell *matHeaderCellDef> Causale </th>
        <td mat-cell *matCellDef="let element">{{element.causale}}</td>
      </ng-container>

      <ng-container matColumnDef="importo">
        <th mat-header-cell *matHeaderCellDef> Importo </th>
        <td mat-cell *matCellDef="let element">{{element.importo |
          currency:'EUR':'symbol':'1.2-2':'it'}}</td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" style="text-align: center; padding: 20px 0;" colspan="4">Nessuna informazione presente al
          momento.
        </td>
      </tr>
    </table>
  </div>
</mat-dialog-content>